<div class="broker-plan-connect-broker-container margin pad-32-bottom position-relative">
    <div class="position-absolute  cursor-pointer close-button" (click)="closeDialog()">
        <mat-icon>close</mat-icon>
    </div>
    <div class="avatar flex-centered-container">
        <img src="/assets/icons/logo-compact.png">
    </div>
    <div class="font-bold text-center">Connect Broker</div>
    <div class="placeholder-text text-center margin-24-top font-14">
        {{
        isCancelSubscription
        ? 'Connect to Broker account to access features.'
        : 'Connect to Broker account or create new account to access features.'
        }}
    
    </div>


    <div class="center-label align-items-center margin-24-top">
        <button mat-flat-button [tabIndex]="-1" color="accent" class="ut-pro-button width-70 gradient"
        (click)="loginShareIndia()">
            Connect Now
        </button>
        <div class="cursor-pointer text-accent font-14 margin-top" *ngIf="!isCancelSubscription"
        (click)="openCreateNewAccount()">
            Create Account
        </div>
    </div>
</div>